var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalLine22 = function SvgDAhuSignalLine22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "178 197.99 178 138 180 138 180 198.01 178 197.99",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178 271.99 178 210 180 210 180 272 178 271.99",
    fill: "#1c9d5b"
  }))));
};
export default SvgDAhuSignalLine22;